import CheckPermission from "../../roles/CheckPermission";
import { MenuSeparator } from "../../navigation/styles";
import MenuItem from "../../metis/MenuItem";
import DashboardIcon from "../../dashboard/DashboardIcon";

const DashboardManage = () => {
      return (
            <>
                  <CheckPermission permission="Dashboard">
                        <MenuSeparator>Dashboard</MenuSeparator>
                        <MenuItem
                              link="/dashboard"
                              title="Dashboard"
                              links={["/dashboard"]}
                              icon={<DashboardIcon />}
                        />
                  </CheckPermission>
            </>
      );
};

export default DashboardManage;
